import React, { useRef, useState } from 'react';
import JoditEditor from 'jodit-react';
import InputTranslater from './InputTranslater';

const RichTextEditor = ({
    defaultValue,
    onChange,
    placeholder = 'Enter your question...',
    className = '',
    language = 'en',
}) => {

    const editor = useRef(null);
    const [content, setContent] = useState(defaultValue || '');
    const [translationText, setTranslationText] = useState('');
    const [isTranslating, setIsTranslating] = useState(false);
    const config = {
        readonly: false,
        toolbar: true,
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough',
            'ol', 'superscript', 'subscript', 'table',
            'symbols', 'preview',
        ],
        removeButtons: [
            'image', 'video', 'file', 'link', 'dots',
            'fontsize', 'source', 'copyformat', 'about', 'print',
            'font', 'brush', 'paragraph', 'eraser',
            'selectall', 'find', 'cut', 'hr', 'indent',
            'outdent', 'undo', 'redo', 'align', 'lineHeight',
            'speechRecognize', 'spellcheck',
        ],

        toolbarAdaptive: false,
        showTooltip: false,
        toolbarButtonSize: 'middle',
        placeholder,
        minHeight: 150,
        maxHeight: 300, // now box can grow
        style: { resize: "vertical", overflow: "auto" }, // allow vertical resize
        enter: 'br', // This makes Enter create <br> instead of <p>
        enterBlock: 'div', // Fallback block element if needed

        pastePlain: true,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        allowPaste: true,

        uploader: { insertImageAsBase64URI: false },
        filebrowser: { ajax: { url: '' } },

        events: {
            paste: function (event) {
                const editor = this;
                const clipboardData = event.clipboardData
                const items = clipboardData?.items;

                if (items) {
                    for (let item of items) {
                        if (item.type.startsWith("image/")) {
                            event.preventDefault();
                            alert("Image pasting is blocked.");
                            return;
                        }
                    }
                }

                event.preventDefault();
                const text = clipboardData?.getData('text/plain');

                // Insert plain text safely using editor.value
                if (text) {
                    // Use setTimeout to insert after paste finishes
                    setTimeout(() => {
                        editor.value = editor.value + text;
                    }, 0);
                }
            },

            drop: function (event) {
                const items = event.dataTransfer?.items;
                if (items) {
                    for (let item of items) {
                        if (item.kind === 'file' && item.type.startsWith("image/")) {
                            event.preventDefault();
                            alert("Image dropping is blocked.");
                            return false;
                        }
                    }
                }
            },
        }
    };




    const handleAddTranslation = () => {
        if (!translationText) return;

        let newContent = content;

        if (newContent) {
            // If there's existing content, add the translation after the first sentence
            const firstPeriodIndex = newContent.indexOf('.');
            const insertionPoint = firstPeriodIndex > -1 ? firstPeriodIndex + 1 : newContent.length;

            newContent =
                newContent.slice(0, insertionPoint) +
                ' ' + translationText +
                newContent.slice(insertionPoint);
        } else {
            // If editor is empty, just set the translation
            newContent = translationText;
        }

        setContent(newContent);
        onChange(newContent);
        setTranslationText('');
        setIsTranslating(false);
    };

    return (
        <div className={`${className}`}>
            <JoditEditor
                ref={editor}
                config={config}
                tabIndex={1}
                value={content}
                onBlur={(newContent) => {
                    onChange(newContent);
                    setContent(newContent)
                }}

            />

            {language !== 'en' && (
                <div className="mt-3">
                    {!isTranslating ? (
                        <button
                            onClick={() => setIsTranslating(true)}
                            className="btn btn-sm btn-outline-secondary"
                        >
                            Add Translation
                        </button>
                    ) : (
                        <div className="d-flex align-items-center gap-2">
                            <InputTranslater
                                type="text"
                                className="form-control"
                                value={translationText}
                                onChangeText={setTranslationText}
                                toLanguage={language}
                                placeholder="Type your translation..."
                                as="textarea"
                            />
                            <button
                                onClick={handleAddTranslation}
                                className="btn btn-sm btn-primary"
                                disabled={!translationText}
                            >
                                Insert
                            </button>
                            <button
                                onClick={() => {
                                    setIsTranslating(false);
                                    setTranslationText('');
                                }}
                                className="btn btn-sm btn-outline-danger"
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default RichTextEditor;